<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <b-card class="animated fadeIn">
            <div slot="header">
              <i class="fa fa-home"></i><strong> Datos CSV</strong>
              <div class="card-header-actions"></div>
            </div>
            <b-row>
              <b-col lg="6">
                <b-card>
                  <b-form-group label="Reporte">
                    <b-form-select
                      v-model="$v.form.report.$model"
                      :state="$v.form.report.$dirty ? !$v.form.report.$error : null"
                      :options="report_type"
                    >
                    </b-form-select>
                  </b-form-group>
                  <b-form-group label="Exportadora">
                    <b-form-select
                      id="client"
                      :state="$v.form.client_customer.$dirty ? !$v.form.client_customer.$error : null"
                      v-model="$v.form.client_customer.$model"
                      :options="customers"
                    />
                  </b-form-group>
                  <b-form-group>
                    <label for="waybill_date">Ingrese dia</label>
                    <b-form-input
                      type="date"
                      id="waybill_date"
                      v-model="$v.form.dateDay.$model"
                      :state="$v.form.dateDay.$dirty ? !$v.form.dateDay.$error : null"
                    ></b-form-input>
                  </b-form-group>
                  <b-button
                    @click="onSubmit"
                    variant="primary"
                    class="float-right"
                    :disabled="$v.form.$invalid || loading == true"
                  >
                    <div v-if="loading == false">Descargar</div>
                    <div v-if="loading" class="align-middle">
                      <b-spinner v-if="loading == true" small type="grow"></b-spinner>Cargando...
                    </div>
                  </b-button>
                </b-card>
              </b-col>
              <b-col lg="6"> </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import numeral from "numeral";
import locales from "numeral/locales";
import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/lib/vue-daterange-picker.min.css";

import { validationMixin } from "vuelidate";
import { required, maxValue, minValue } from "vuelidate/lib/validators";

numeral.locale("es");
moment.locale("es");
window.axios = require("axios");

export default {
  name: "ReportExcel",
  components: {
    DateRangePicker
  },
  created() {},
  beforeMount() {
    this.getCustomers();
  },
  data() {
    return {
      loading: false,
      customers: [{ value: "", text: "Cargando..." }],
      autoApply: true,
      now: moment(new Date()).format(),
      report_type: [{ value: 1, text: "Detalle inspecciones por dia" }],
      form: {
        report: null,
        from: null,
        to: null,
        dateDay: null,
        client_customer: ""
      },
      DirLaravel: localStorage.getItem("qc_api_url")
      /*  DirLaravel:"http://localhost/packingonline/public/", */
    };
  },
  validations: {
    form: {
      report: {
        required
      },
      dateDay: {
        required
      },
      client_customer: {
        required
      }
    }
  },
  computed: {},
  filters: {
    moment: function (date) {
      return moment(date).format("DD-MM-YYYY");
    },
    decimal(value) {
      return numeral(value).format("0,0.00");
    }
  },
  methods: {
    getCustomers() {
      this.$axios
        .get("/production/get_customers/")
        .then((res) => {
          const data = res.data.data;
          const customers = [];
          for (let key in data) {
            const customer = data[key];
            customers.push(customer);
          }
          this.customers = customers;
        })
        .catch((error) => console.log(error));
    },
    onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }
      //this.loading = true
      window.open(
        this.DirLaravel +
          "controlcalidad/detalle_reporte_inspecciones/" +
          this.form.client_customer +
          "/" +
          this.form.dateDay +
          "",
        "_blank",
        ""
      );
    }
  }
};
</script>

<style scoped></style>
